import { gql } from "@apollo/client";

export const GET_REQ_CLIENTES_EXPORT = gql`
query clientesExportByDelegacion($idDelegacion: Int!) {
    clientesExportByDelegacion(idDelegacion: $idDelegacion)
    {
        success,
        error,
        valorEsperado {
          cOD_SAP
          cUIT
          nOMBRE
          dELEGACION
          pERSONA_CONTACTO
          cARGO
          tELEFONO
          mAIL
          tIEMPO_MAX_FACT
          iNICIO_FACT
          fIN_FACT
          hABILITADO_FA
          dOC_RESPALDATORIA
          pRESENTACION_FACT
          mAIL_FACT
          oBSERVACIONES
          aUTORIZACIONES
          tM_AUTORIZACIONES
          cONFORMIDADES
          tM_CONFORMIDADES
          eNFERMERIA
          tM_ENFERMERIA
          rEMITO_NH
          tM_REMITO_NH
          iDTIPOREMITONH
          rEMITO_FK
          tM_REMITO_FK
          iDTIPOREMITOFK
          pRESCRIPCION
          tM_PRESCRIPCION
          vALIDACION
          tM_VALIDACION
          dOCUMENTACION_PAC
          tM_DOCUMENTACION_PAC
          eNFERMERIAGUARDIA
          tM_ENFERMERIAGUARDIA
          nUTRICIONISTA
          tM_NUTRICIONISTA
          fONOAUDIOLOGO
          tM_FONOAUDIOLOGO
          pSICOLOGO
          tM_PSICOLOGO
          kINESIOLOGO
          tM_KINESIOLOGO
          tOCUPACIONAL
          tM_TOCUPACIONAL
          aSOCIAL
          tM_ASOCIAL
          pSIQUIATRA
          tM_PSIQUIATRA
          tELEMEDICINA
          sUBVENTAS
        }
    }
}`;

export const adaptClienteToExport = (cliente) => ({
  cOD_SAP: cliente.cOD_SAP,
  cUIT: cliente.cUIT,
  nOMBRE: cliente.nOMBRE,
  dELEGACION: cliente.dELEGACION,
  pERSONA_CONTACTO: cliente.pERSONA_CONTACTO,
  cARGO: cliente.cARGO,
  tELEFONO: cliente.tELEFONO,
  mAIL: cliente.mAIL,
  tIEMPO_MAX_FACT: cliente.tIEMPO_MAX_FACT,
  iNICIO_FACT: cliente.iNICIO_FACT,
  fIN_FACT: cliente.fIN_FACT,
  hABILITADO_FA: cliente.hABILITADO_FA,
  dOC_RESPALDATORIA: cliente.dOC_RESPALDATORIA,
  pRESENTACION_FACT: cliente.pRESENTACION_FACT,
  mAIL_FACT: cliente.mAIL_FACT,
  oBSERVACIONES: cliente.oBSERVACIONES,
  aUTORIZACIONES: cliente.aUTORIZACIONES,
  tM_AUTORIZACIONES: cliente.tM_AUTORIZACIONES,
  cONFORMIDADES: cliente.cONFORMIDADES,
  tM_CONFORMIDADES: cliente.tM_CONFORMIDADES,
  eNFERMERIA: cliente.eNFERMERIA,
  tM_ENFERMERIA: cliente.tM_ENFERMERIA,
  rEMITO_NH: cliente.rEMITO_NH,
  tM_REMITO_NH: cliente.tM_REMITO_NH,
  iDTIPOREMITONH: cliente.iDTIPOREMITONH,
  rEMITO_FK: cliente.rEMITO_FK,
  tM_REMITO_FK: cliente.tM_REMITO_FK,
  iDTIPOREMITOFK: cliente.iDTIPOREMITOFK,
  pRESCRIPCION: cliente.pRESCRIPCION,
  tM_PRESCRIPCION: cliente.tM_PRESCRIPCION,
  vALIDACION: cliente.vALIDACION,
  tM_VALIDACION: cliente.tM_VALIDACION,
  dOCUMENTACION_PAC: cliente.dOCUMENTACION_PAC,
  tM_DOCUMENTACION_PAC: cliente.tM_DOCUMENTACION_PAC,
  eNFERMERIAGUARDIA: cliente.eNFERMERIAGUARDIA,
  tM_ENFERMERIAGUARDIA: cliente.tM_ENFERMERIAGUARDIA,
  nUTRICIONISTA: cliente.nUTRICIONISTA,
  tM_NUTRICIONISTA: cliente.tM_NUTRICIONISTA,
  fONOAUDIOLOGO: cliente.fONOAUDIOLOGO,
  tM_FONOAUDIOLOGO: cliente.tM_FONOAUDIOLOGO,
  pSICOLOGO: cliente.pSICOLOGO,
  tM_PSICOLOGO: cliente.tM_PSICOLOGO,
  kINESIOLOGO: cliente.kINESIOLOGO,
  tM_KINESIOLOGO: cliente.tM_KINESIOLOGO,
  tOCUPACIONAL: cliente.tOCUPACIONAL,
  tM_TOCUPACIONAL: cliente.tM_TOCUPACIONAL,
  aSOCIAL: cliente.aSOCIAL,
  tM_ASOCIAL: cliente.tM_ASOCIAL,
  pSIQUIATRA: cliente.pSIQUIATRA,
  tM_PSIQUIATRA: cliente.tM_PSIQUIATRA,
  tELEMEDICINA: cliente.tELEMEDICINA ? 'SI' : 'NO',
  sUBVENTAS: cliente.sUBVENTAS ? 'SI' : 'NO'
});

export const adaptClientesToExportArray = (clientes) =>
structuredClone(clientes)?.
map((cliente) => adaptClienteToExport(cliente));